import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';
import { MiViewColors, MiViewBorderRadius, MiViewSpacing, MiViewFontSize } from 'miview-ui/miviewTheme';

export const formControlStyle: SxProps<Theme> = {
  ml: 'auto',
  marginRight: MiViewSpacing.small,
  maxWidth: 120,
  width: '100%',
  label: {
    opacity: 1,
    transition: 'all 0.3s ease',
  },
  '@media (max-width: 1450px)': {
    marginRight: MiViewSpacing.xxSmall,
  },
};

export const inputLabelStyle: SxProps<Theme> = {
  color: MiViewColors.tertiary,
  fontSize: MiViewFontSize.small,
  '&.Mui-focused': {
    color: MiViewColors.tertiary,
  },

  '@media (max-width: 1450px)': {
    width: '48px',
    '&.MuiFormLabel-filled': {
      width: '100%',
    },
    '&.Mui-focused': {
      width: '100%',
    },
  },
  '@media (max-width: 1380px)': {
    width: '30px',
  },
  '@media (max-width: 1279px)': {
    width: '100%',
  },
};

export const selectStyle = {
  fontSize: MiViewFontSize.small,
  color: MiViewColors.quaternary,
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
};

export const selectPaperStyle: SxProps<Theme> = {
  maxHeight: '50vh',
  '&::-webkit-scrollbar': {
    width: '4px',
    height: '4px',
    overflowY: 'scroll',
    background: MiViewColors.lightGray,
  },
  '&::-webkit-scrollbar-thumb': {
    background: MiViewColors.gray,
    borderRadius: MiViewBorderRadius.xSmall,
  },
};

export const menuItemStyle: SxProps<Theme> = {
  fontSize: MiViewFontSize.small,
};
